import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { cn } from "../../../../shared/utils/index.js";
import { Check, Copy } from "lucide-react";
import { useState } from "react";
export function CopyToClipboard(t0) {
  const $ = _c(10);
  const {
    text,
    onCopy,
    children,
    className
  } = t0;
  const [copied, setCopied] = useState(false);
  let t1;
  if ($[0] !== onCopy || $[1] !== text) {
    t1 = async () => {
      if (!text) {
        return;
      }
      await navigator.clipboard.writeText(text);
      setCopied(true);
      onCopy?.();
      setTimeout(() => setCopied(false), 2000);
    };
    $[0] = onCopy;
    $[1] = text;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleCopy = t1;
  if (children) {
    let t2;
    if ($[3] !== children || $[4] !== handleCopy) {
      t2 = _jsx("div", {
        onClick: handleCopy,
        className: "cursor-pointer",
        children
      });
      $[3] = children;
      $[4] = handleCopy;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  let t2;
  if ($[6] !== className || $[7] !== copied || $[8] !== handleCopy) {
    t2 = _jsx("div", {
      onClick: handleCopy,
      className: cn("text-b3-foreground-muted hover:text-b3-foreground-muted/80 flex cursor-pointer items-center gap-1 text-xs transition-all duration-200", className),
      children: copied ? _jsx(_Fragment, {
        children: _jsx(Check, {
          className: "h-4 w-4"
        })
      }) : _jsx(_Fragment, {
        children: _jsx(Copy, {
          className: "h-4 w-4"
        })
      })
    });
    $[6] = className;
    $[7] = copied;
    $[8] = handleCopy;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}